export const getColorFromFabricShape = (shape) => {
  const shapeColorHex = shape.get("stroke") || shape.get("fill") || shape.fill;
  //   const isSvgShape = lastActiveObject.fromSVG;
  return shapeColorHex;
};
